import { render, staticRenderFns } from "./StandardTab.vue?vue&type=template&id=409f9234&"
import script from "./StandardTab.vue?vue&type=script&lang=js&"
export * from "./StandardTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports